export enum DefaultGroupFieldNamesEnum {
    basic_information = 'Basic Information',
    personal_information = 'Personal Information',
    address = 'Address',
    emergency_contacts = 'Emergency Contacts',
    employment_information = 'Employment Information',
    bank_account = 'Bank Account',
}
